  if($(".has-jQuery-pagination").length > 0){
	$.getScript( "https://cdnjs.cloudflare.com/ajax/libs/twbs-pagination/1.4.1/jquery.twbsPagination.min.js", function() {
		 jQueryPaginationPlugin();
	});
  }

  function jQueryPaginationPlugin(){
    var pager = $("#green-pagination");
    var totalPages = $('.no-of-pages').val();//pager.data('page-numbers');
    if(totalPages == 0)
	{
		return;
	}
	var startPage = 1;
    var hasPage = false;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++){
        if (hashes[i].indexOf("page") > -1){
          var hash = hashes[i].split('=');
          if (parseInt(hash[1]) <= totalPages) {
            startPage = parseInt(hash[1]);
          }
        }
    }

    pager.twbsPagination({
    totalPages: totalPages,
    startPage: startPage,

    // maximum visible pages
    visiblePages: 10,

    // // template for pagination links
    href: false,

    // variable name in href template for page number
    hrefVariable: '{{number}}',
    pageVariable:'{{page}}',

    // Text labels
    prev: '&lsaquo; <span class="hidden-xs hidden-sm">Previous</span>',
    next: '<span class="hidden-xs hidden-sm">Next</span> &rsaquo;',
    first:'',
    last:'',


    // // callback function
    onPageClick: function (event, page) {
     var queyString = [];
	  if (window.location.href.split('?').length == 1)
	  {
		  queyString.push("page="+page);
	  }
	  else if(window.location.href.split('?')[1].length == 0)
	  {
		  queyString.push("page="+page);
	  }
	  else
	  {
		  for (var i = 0; i < hashes.length; i++){
          if (hashes[i].includes("page")){
            var hash = hashes[i].split('=');
            queyString.push("page="+page);
            hasPage =  true;
          } else {
            queyString.push(hashes[i]);
          }
		  }
		  if (!hasPage){
			queyString.push("page="+page);
		  }
	  }

        location.assign('?'+queyString.join('&'));
    },
    //
    // // pagination Classes
    nextClass: 'nxt',
    prevClass: 'pre',
    pageClass: 'br-1',
    activeClass: 'green-pagination-active',
    initiateStartPageClick: false,
    });
  };

if ($(".has-pagination").length > 0) {

    $(document).ready(function () {

        var totalPages = parseInt($('.hdnnoofpages').val(), 10);             // <-- set this dynamically from your data source
        var currentPage = getCurrentPage();

        renderPagination(currentPage, totalPages);

        // ---- Helpers ----

        function getCurrentPage() {
            var params = new URLSearchParams(window.location.search);
            var page = parseInt(params.get('page'), 10);
            return (!page || page < 1) ? 1 : page;
        }

        function buildPageUrl(pageNum) {
            var url = new URL(window.location.href);
            var pathname = url.pathname.replace(/\/page\/\d+\/?$/, '/'); // strip /page/N/ if present
            var params = url.searchParams;
            params.set('page', pageNum);
            return url.origin + pathname + '?' + params.toString();
        }

        // Builds the array of page "tokens" to render: numbers + '...' dots
        function getPageRange(current, total) {
            var delta = 1; // how many neighbors to show around current
            var range = [];
            var rangeWithDots = [];
            var l;

            for (var i = 1; i <= total; i++) {
                if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
                    range.push(i);
                }
            }

            range.forEach(function (i) {
                if (l) {
                    if (i - l === 2) {
                        rangeWithDots.push(l + 1);
                    } else if (i - l !== 1) {
                        rangeWithDots.push('...');
                    }
                }
                rangeWithDots.push(i);
                l = i;
            });

            return rangeWithDots;
        }

        function renderPagination(current, total) {
            var $container = $('.pagination-control');
            $container.empty();
            if (total <= 1) return; // nothing to paginate

            var pages = getPageRange(current, total);

            // Previous button
            if (current > 1) {
                $container.append(
                    '<a class="prev page-numbers" href="' + buildPageUrl(current - 1) + '" data-page="' + (current - 1) + '">Previous</a>'
                );
            }

            pages.forEach(function (p) {
                if (p === '...') {
                    $container.append('<span class="page-numbers dots">...</span>');
                } else if (p === current) {
                    $container.append(
                        '<span aria-current="page" class="page-numbers current">' + p + '</span>'
                    );
                } else {
                    $container.append(
                        '<a class="page-numbers" href="' + buildPageUrl(p) + '" data-page="' + p + '">' + p + '</a>'
                    );
                }
            });

            // Next button
            if (current < total) {
                $container.append(
                    '<a class="next page-numbers" href="' + buildPageUrl(current + 1) + '" data-page="' + (current + 1) + '">Next</a>'
                );
            }

            $container.append(
                '<a href="' + buildPageUrl(total) + '" title="Last page" class="page-numbers last-page" data-page="' + total + '">Last</a>'
            );
        }

        // ---- Click handling (delegated, since links are dynamic) ----
        $('.pagination-control').on('click', 'a.page-numbers', function (e) {
            e.preventDefault();
            var pageNum = $(this).data('page');
            window.location.href = buildPageUrl(pageNum);
        });

    });

}
